import { render, staticRenderFns } from "./UserErpModal.vue?vue&type=template&id=8206b686"
import script from "./UserErpModal.vue?vue&type=script&lang=js"
export * from "./UserErpModal.vue?vue&type=script&lang=js"
import style0 from "./UserErpModal.vue?vue&type=style&index=0&id=8206b686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports